import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next'; 

const EmailContent = ({ content }) => {
  const iframeRef = useRef(null);
  const { t } = useTranslation();

  const renderContent = () => {
    if (iframeRef.current) {
      const iframe = iframeRef.current;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      
      const htmlContent = content ? content : `<p style="text-align: center;padding-top: 50px;">${t('Mail non disponible')}</p>`;
      
      iframeDoc.open();
      iframeDoc.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <style>
            body { margin: 0; padding: 0; font-family: inherit; }
          </style>
        </head>
        <body>
          ${htmlContent}
        </body>
        </html>
      `);
      iframeDoc.close();
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      renderContent();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    renderContent();
  }, [content, t]);

  return <iframe ref={iframeRef} />;
};
export { EmailContent };